import { SIZE_KEYS } from '../constans/styles';

type TSizeKeys = typeof SIZE_KEYS[number];

type TSizes = Record<
  Extract<TSizeKeys, 'mikro' | 'mili' | 'centy' | 'decy' | 'deka' | 'hekto' | 'mega' | 'giga'>,
  string
>;

const SIZES: TSizes = {
  mikro: '14px',
  mili: '16px',
  centy: '20px',
  decy: '24px',
  deka: '32px',
  hekto: '36px',
  mega: '40px',
  giga: '64px',
};

export const TYPOGRAPHY = {
  sizes: SIZES,
} as const;
